import React, { createContext, useContext, useState, useEffect } from 'react';

const BrandingContext = createContext();

const DEFAULT_BRANDING = {
  logoUrl: null,
  companyName: '',
  primaryColor: '#16a34a', // green-600
  accentColor: '#059669', // emerald-600
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(() => {
    const saved = localStorage.getItem('1data_branding');
    return saved ? JSON.parse(saved) : DEFAULT_BRANDING;
  });

  useEffect(() => {
    localStorage.setItem('1data_branding', JSON.stringify(branding));
    // Apply primary color as CSS variable
    document.documentElement.style.setProperty('--client-primary', branding.primaryColor);
    document.documentElement.style.setProperty('--client-accent', branding.accentColor);
  }, [branding]);

  const updateBranding = (updates) => {
    setBranding(prev => ({ ...prev, ...updates }));
  };

  const resetBranding = () => {
    setBranding(DEFAULT_BRANDING);
  };

  return (
    <BrandingContext.Provider value={{ branding, updateBranding, resetBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) throw new Error('useBranding must be used within BrandingProvider');
  return context;
};
